module.exports = __webpack_public_path__ + "static/media/intro-2.26e33860.png";